import { Toaster as Sonner, toast } from "sonner";
import { useThemeContext } from "@/components/common/ThemeProvider";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  let theme: ToasterProps["theme"] = "system";
  try {
    const ctx = useThemeContext();
    theme = ctx.resolvedTheme as ToasterProps["theme"];
  } catch {
    // Fora do provider — fallback seguro
    theme = "system";
  }

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-surface group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-attio-md",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success: "group-[.toaster]:!border-success/30 group-[.toaster]:!text-foreground",
          error: "group-[.toaster]:!border-destructive/30 group-[.toaster]:!text-foreground",
          warning: "group-[.toaster]:!border-warning/30 group-[.toaster]:!text-foreground",
          info: "group-[.toaster]:!border-info/30 group-[.toaster]:!text-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
